import React, {useEffect, useState} from "react";
import { getLeaderboard } from "../api";
import InteractiveMascot from '../components/InteractiveMascot';

export default function Leaderboard() {
  // Support Class 4 and 5
  const [klass, setKlass] = useState(4);
  const [data, setData] = useState([]);
  useEffect(()=>{
    getLeaderboard(klass).then(setData);
  }, [klass]);
  return (
    <div className="min-h-screen bg-gradient-to-br from-yellow-50 to-orange-50 py-8">
      <div className="container mx-auto px-4 max-w-4xl">
        <div className="bg-white rounded-xl shadow-lg p-8">
          <div className="text-center mb-8">
            <h2 className="text-4xl font-bold text-gray-900 mb-2">🏆 Class {klass} Leaderboard</h2>
            <p className="text-gray-600">Top performers in Class {klass} mathematics</p>
            
            {/* Class Selector */}
            <div className="flex justify-center gap-4 mt-4">
              <button
                onClick={() => setKlass(4)}
                className={`px-6 py-2 rounded-lg font-semibold transition-all ${
                  klass === 4 
                    ? 'bg-blue-600 text-white' 
                    : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                }`}
              >
                Class 4
              </button>
              <button
                onClick={() => setKlass(5)}
                className={`px-6 py-2 rounded-lg font-semibold transition-all ${
                  klass === 5 
                    ? 'bg-blue-600 text-white' 
                    : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                }`}
              >
                Class 5
              </button>
            </div>
          </div>
          <div className="space-y-3">
            {data.length === 0 && (
              <div className="text-center py-12 text-gray-500">
                <div className="text-6xl mb-4">🎯</div>
                <p className="text-lg">No scores yet — be the first to top the leaderboard!</p>
              </div>
            )}
            {data.map((r, i)=>{
              const medals = ['🥇', '🥈', '🥉'];
              const medal = i < 3 ? medals[i] : `#${i+1}`;
              return (
                <div 
                  key={r.id} 
                  className={`p-4 rounded-lg flex justify-between items-center transition-all hover:scale-102 ${
                    i === 0 ? 'bg-gradient-to-r from-yellow-100 to-yellow-200 border-2 border-yellow-400' :
                    i === 1 ? 'bg-gradient-to-r from-gray-100 to-gray-200 border-2 border-gray-400' :
                    i === 2 ? 'bg-gradient-to-r from-orange-100 to-orange-200 border-2 border-orange-400' :
                    'bg-gray-50 border border-gray-200'
                  }`}
                >
                  <div className="flex items-center space-x-4">
                    <div className="text-3xl font-bold w-12 text-center">
                      {medal}
                    </div>
                    <div>
                      <div className="font-bold text-lg text-gray-900">Player {r.user_id}</div>
                      <div className="text-sm text-gray-600">
                        {r.correct}/{r.total} correct • {new Date(r.created_at).toLocaleDateString()}
                      </div>
                    </div>
                  </div>
                  <div className="text-right">
                    <div className="text-3xl font-extrabold text-primary">{r.score}</div>
                    <div className="text-xs text-gray-500">points</div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      
      {/* Interactive Mascot */}
      <InteractiveMascot 
        position="bottom-right"
        onInteraction={(type, data) => console.log('Leaderboard mascot interaction:', type, data)}
      />
    </div>
  );
}
